/* Inquiry identity, attribution and consent snapshot. No network requests. v3 */
(function () {
  'use strict';
  if (window.__nhlInquiryAttribution) return;
  window.__nhlInquiryAttribution = true;
  var KEY = 'nhl:inquiry:attribution:v1', TTL = 30 * 86400000;
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'placement'];
  var LABELS = ['Source', 'Medium', 'Campaign', 'Ad set', 'Ad', 'Placement'];
  var GOOGLE_CLICK_PARAMS = ['gclid', 'gbraid', 'wbraid'];
  var GOOGLE_CLICK_LABELS = ['GCLID', 'GBRAID', 'WBRAID'];
  var memory = null;
  function permitted() {
    try {
      var p = window.Shopify.customerPrivacy;
      return p.analyticsProcessingAllowed() && p.marketingAllowed();
    } catch (_) { return false; }
  }
  function clean(value) {
    // Campaign metadata only; reject unresolved macros, control chars and email-like values.
    return typeof value === 'string' && /^[a-zA-Z0-9_. -]{1,120}$/.test(value) ? value : '';
  }
  function cleanGoogleClick(value) {
    // Google click identifiers are URL-safe opaque values, never invented or derived.
    return typeof value === 'string' && /^[a-zA-Z0-9._~-]{1,500}$/.test(value) ? value : '';
  }
  function cleanPath(value) {
    return typeof value === 'string' && value.length <= 500 && value.charAt(0) === '/' && !/[\u0000-\u001f\u007f]/.test(value) ? value : '';
  }
  function touchValid(t) {
    return t && Number.isFinite(t.at) && Date.now() >= t.at && Date.now() - t.at < TTL &&
      Array.isArray(t.values) && t.values.length === 6 && t.values.every(function(v) { return v === '' || clean(v) === v; }) &&
      (typeof t.googleClicks === 'undefined' || (Array.isArray(t.googleClicks) && t.googleClicks.length === 3 &&
        t.googleClicks.every(function(v) { return v === '' || cleanGoogleClick(v) === v; }))) &&
      (typeof t.landingPath === 'undefined' || cleanPath(t.landingPath) === t.landingPath);
  }
  function read() {
    try {
      var r = JSON.parse(localStorage.getItem(KEY));
      if (r && touchValid(r.first) && touchValid(r.last)) return r;
      localStorage.removeItem(KEY);
    } catch (_) { /* Storage denied: retain current-page attribution in memory only. */ }
    return memory && touchValid(memory.first) && touchValid(memory.last) ? memory : null;
  }
  function capture() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return null;
    if (!permitted()) {
      memory = null;
      try { localStorage.removeItem(KEY); } catch (_) {}
      return null;
    }
    var r = read(), q = new URLSearchParams(location.search);
    var values = PARAMS.map(function(k) { return clean(q.get(k)); });
    var googleClicks = GOOGLE_CLICK_PARAMS.map(function(k) { return cleanGoogleClick(q.get(k)); });
    if ((values[0] && values[1]) || googleClicks.some(function(v) { return !!v; })) {
      var t = {at: Date.now(), values: values, googleClicks: googleClicks, landingPath: cleanPath(location.pathname)};
      // Do not reset the timestamp on every form submission on the same page.
      if (!r || JSON.stringify([r.last.values, r.last.googleClicks || [], r.last.landingPath || '']) !== JSON.stringify([values, googleClicks, t.landingPath])) {
        r = {first: r ? r.first : t, last: t};
      }
    }
    memory = r;
    try { if (r) localStorage.setItem(KEY, JSON.stringify(r)); } catch (_) {}
    return r;
  }
  function field(form, label, value) {
    var name = 'contact[' + label + ']';
    var el = form.querySelector('input[name="' + name + '"]');
    if (!el) {
      el = document.createElement('input'); el.type = 'hidden'; el.name = name;
      el.setAttribute('data-nhl-attribution', 'true'); form.appendChild(el);
    }
    el.value = value;
    el.setAttribute('value', value);
  }
  function permissionSnapshot() {
    var result = {analytics: 'unknown', marketing: 'unknown', sale: 'unknown'};
    try {
      var p = window.Shopify.customerPrivacy;
      [['analytics','analyticsProcessingAllowed'],['marketing','marketingAllowed'],['sale','saleOfDataAllowed']].forEach(function(pair) {
        if (p && typeof p[pair[1]] === 'function') {
          var value = p[pair[1]]();
          if (typeof value === 'boolean') result[pair[0]] = value ? 'allowed' : 'denied';
        }
      });
    } catch (_) {}
    return result;
  }
  function metaCookie(name) {
    try {
      var value = document.cookie.split(';').map(function(s) { return s.trim(); }).find(function(s) { return s.indexOf(name + '=') === 0; });
      value = value ? value.slice(name.length + 1) : '';
      return /^fb\.\d\.\d{13}\.[a-zA-Z0-9_-]{1,500}$/.test(value) ? value : '';
    } catch (_) { return ''; }
  }
  function measurement(form, submitting) {
    if (['commission-form','contact-band-form'].indexOf(form.id) === -1) return;
    var p = permissionSnapshot(), shop = window.Shopify;
    var live = shop && shop.theme && shop.theme.role === 'main' && !shop.designMode && !/[?&](preview_theme_id|preview_key|preview_script_id)=/.test(location.search);
    field(form, 'Tracking version', live ? '3' : 'preview');
    field(form, 'Tracking event ID', form.__nhlInquiryId);
    field(form, 'Tracking analytics', p.analytics);
    field(form, 'Tracking marketing', p.marketing);
    field(form, 'Tracking data sharing', p.sale);
    if (!submitting) return;
    var selected = form.querySelector('input[data-label="Build type"]:checked');
    var type = form.id === 'commission-form' ? (selected && selected.value === 'Mod my existing watch' ? 'watch_modification' : 'custom_watch') : 'general';
    field(form, 'Tracking inquiry type', type);
    field(form, 'Tracking submitted UTC', new Date().toISOString());
    field(form, 'Tracking source URL', location.origin + location.pathname);
    // Read genuine existing Meta cookies only when all relevant purposes are allowed.
    // No fabricated click IDs and no browser IP collection.
    if (live && p.analytics === 'allowed' && p.marketing === 'allowed' && p.sale === 'allowed') {
      field(form, 'Tracking browser ID', metaCookie('_fbp'));
      field(form, 'Tracking click ID', metaCookie('_fbc'));
      field(form, 'Tracking user agent', navigator.userAgent.slice(0,500));
    }
  }
  function populate(form, r, submitting) {
    if (!form.querySelector('input[name="contact[email]"]')) return;
    if (!form.__nhlInquiryId) {
      if (!window.crypto || typeof window.crypto.randomUUID !== 'function') return;
      form.__nhlInquiryId = 'NHL-' + window.crypto.randomUUID();
    }
    field(form, 'Inquiry ID', form.__nhlInquiryId);
    form.querySelectorAll('input[data-nhl-attribution="true"]').forEach(function(el) {
      if (el.name !== 'contact[Inquiry ID]') el.remove();
    });
    measurement(form, submitting);
    if (!r) return;
    ['first', 'last'].forEach(function(which) {
      var prefix = which === 'first' ? 'First ad visit - ' : 'Latest ad visit - ';
      var touch = r[which];
      touch.values.forEach(function(value, i) { if (value) field(form, prefix + LABELS[i], value); });
      (touch.googleClicks || []).forEach(function(value, i) { if (value) field(form, prefix + GOOGLE_CLICK_LABELS[i], value); });
      if (touch.landingPath) field(form, prefix + 'Landing path', touch.landingPath);
      field(form, prefix + 'Date UTC', new Date(touch.at).toISOString());
    });
  }
  function refresh() {
    var r = capture();
    document.querySelectorAll('form').forEach(function(form) { populate(form, r); });
  }
  // Capture phase ensures fields exist before native form serialization.
  document.addEventListener('submit', function(e) {
    try { populate(e.target, capture(), true); } catch (_) { /* Never block native form delivery. */ }
  }, true);
  document.addEventListener('visitorConsentCollected', refresh);
  function start() {
    refresh();
    var shop = window.Shopify;
    if (shop && !shop.customerPrivacy && typeof shop.loadFeatures === 'function') {
      shop.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function(error) { if (!error) refresh(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
